import { LoadingOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import React from 'react';
import { Link } from 'react-router-dom';
import { getProductId } from '@/infrastructure/product-info';
import { hintIconText } from '@/presentation/components/hint-text/hintText';
import { stores } from '@/presentation/store';
import { continuousEventService, IContinuationDef, IGetProductConfigReq } from '@/service/continuous-event';


export const ContinuousEventTips = () => {
  const { pid } = stores.ProductStore;
  const { data, loading, run } = useRequest<IContinuationDef,
  IGetProductConfigReq[]>(
    (args: IGetProductConfigReq) => continuousEventService.getProductConfig(args),
    {
      manual: true,
      defaultParams: [{ productId: getProductId() }],
    },
  );

  const onVisibleChange = (visible: boolean) => {
    visible && run({ productId: getProductId() });
  };

  return hintIconText(
    '连续崩溃',
    <span>在周期T内，相同设备ID连续崩溃了N次，标为连续崩溃。
当前周期T为{loading ? <LoadingOutlined /> : ((data?.periodSec || 0) / 60).toFixed(0)}分钟，
      崩溃次数N为{loading ? <LoadingOutlined /> : data?.occurCount || 0}，
      产品管理员可以「<Link to={`/setting/product-config?productId=${getProductId()}&pid=${pid}&tab=continuousCrash`}>修改连续崩溃配置</Link>」。</span>,
    'top',
    onVisibleChange,
  );
};
